export default __webpack_public_path__ + "maps-examples-constraining-gestures-thumbnail-480-d660450b9e0f8449e0b9d3f2fc2f75ca.png";